
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("ViizB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $913918b857124f34$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $913918b857124f34$export$2e2bcd8739ae039 = {
    'fabric.emoji.add.custom.emoji.label': "Ajouter votre propre \xe9motic\xf4ne",
    'fabric.emoji.add.label': "Ajouter une \xe9motic\xf4ne",
    'fabric.emoji.cancel.label': 'Annuler',
    'fabric.emoji.categories.label': "Choisir une cat\xe9gorie d'\xe9motic\xf4nes",
    'fabric.emoji.categories.search.results': "R\xe9sultats de recherche",
    'fabric.emoji.category.activity': "Activit\xe9",
    'fabric.emoji.category.all.uploads': 'Tous les chargements',
    'fabric.emoji.category.flags': 'Drapeaux',
    'fabric.emoji.category.foods': 'Aliments et boissons',
    'fabric.emoji.category.frequent': "Fr\xe9quents",
    'fabric.emoji.category.nature': 'Nature',
    'fabric.emoji.category.objects': 'Objets',
    'fabric.emoji.category.people': 'Personnes',
    'fabric.emoji.category.places': 'Voyage et lieux',
    'fabric.emoji.category.productivity': "Productivit\xe9",
    'fabric.emoji.category.symbols': 'Symboles',
    'fabric.emoji.category.user.uploads': 'Vos chargements',
    'fabric.emoji.choose.file.screenReaderDescription': "S\xe9lectionnez un fichier pour l'\xe9motic\xf4ne. Il doit \xeatre au format\xa0JPG, PNG ou GIF. Taille maximale\xa0: 1\xa0Mo.",
    'fabric.emoji.choose.file.title': "S\xe9lectionner un fichier",
    'fabric.emoji.delete.description': "Toutes les instances existantes de cette \xe9motic\xf4ne seront remplac\xe9es par {emojiShortName}",
    'fabric.emoji.delete.label': 'Supprimer',
    'fabric.emoji.delete.screenreader.tooltip': "Pour supprimer l'\xe9motic\xf4ne {shortName}, appuyez sur la touche Retour arri\xe8re",
    'fabric.emoji.delete.title': "Supprimer l'\xe9motic\xf4ne",
    'fabric.emoji.delete.tooltip': 'Supprimer',
    'fabric.emoji.emojipicker.emoi.roledescription': "bouton d'\xe9motic\xf4ne",
    'fabric.emoji.emojipicker.error': "Erreur\xa0!",
    'fabric.emoji.error.delete.failed': "\xc9chec de la suppression",
    'fabric.emoji.error.image.too.big': "L'image s\xe9lectionn\xe9e est sup\xe9rieure \xe0 1\xa0Mo",
    'fabric.emoji.error.invalid.image': "L'image s\xe9lectionn\xe9e n'est pas valide",
    'fabric.emoji.error.upload.failed': "\xc9chec du chargement",
    'fabric.emoji.error.upload.timeout': "L'importation a expir\xe9",
    'fabric.emoji.image.requirements': "JPG, PNG ou GIF. Taille max.\xa0: 1\xa0Mo.",
    'fabric.emoji.name.ariaLabel': 'Saisissez le nom du nouvel emoji',
    'fabric.emoji.picker': "S\xe9lecteur d'\xe9motic\xf4ne",
    'fabric.emoji.pickerlist.grid': "{showSearchResults, select, true {R\xe9sultats de la recherche} other {\xc9motic\xf4nes}}",
    'fabric.emoji.pickerlist.tabpanel': "Volet d'actions d'\xe9motic\xf4ne et de listes",
    'fabric.emoji.placeholder': "Par exemple\xa0: bonjour",
    'fabric.emoji.preview': "Votre nouvelle \xe9motic\xf4ne {emoji} est super",
    'fabric.emoji.preview.title': "Afficher un aper\xe7u",
    'fabric.emoji.retry.label': "R\xe9essayer",
    'fabric.emoji.search.label': "Nom de l'\xe9motic\xf4ne",
    'fabric.emoji.search.placeholder': 'Rechercher',
    'fabric.emoji.search.status': "Voir toutes les \xe9motic\xf4nes",
    'fabric.emoji.select.skin.list.ariaLabel': "S\xe9lecteur de phototype",
    'fabric.emoji.select.skin.tone.ariaLabel': "Choisissez votre phototype\xa0; phototype s\xe9lectionn\xe9\xa0: {selectedTone}"
};

});


//# sourceMappingURL=fr.a6fdeb9b.js.map
